__turbopack_context__.v({
  "errorMessage": "nChSWG_errorMessage",
  "statusDisplay": "nChSWG_statusDisplay",
  "statusDropdown": "nChSWG_statusDropdown",
  "statusIcon": "nChSWG_statusIcon",
  "statusLabel": "nChSWG_statusLabel",
});
